// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var financialRouter = {
  path: '/financial',
  component: Layout,
  redirect: '/financial/commission/template',
  name: 'Financial',
  meta: {
    title: '财务',
    icon: 'clipboard'
  },
  children: [{
    path: 'commission',
    component: function component() {
      return import('@/views/financial/index');
    },
    name: 'Commission',
    meta: {
      title: '财务操作',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'template',
      component: function component() {
        return import('@/views/financial/commission/withdrawal/index');
      },
      name: 'commissionTemplate',
      meta: {
        title: '申请提现',
        icon: ''
      }
    }, {
      path: 'realName',
      component: function component() {
        return import('@/views/financial/commission/realName/index');
      },
      name: 'realNameAudit',
      meta: {
        title: '实名认证审核',
        icon: ''
      }
    }, {
      path: 'setting',
      component: function component() {
        return import('@/views/financial/commission/setting/index');
      },
      name: 'financeSetting',
      meta: {
        title: '财务设置',
        icon: ''
      }
    }]
  }, {
    path: 'storeFinance',
    component: function component() {
      return import('@/views/financial/index');
    },
    name: 'StoreFinance',
    meta: {
      title: '门店财务',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'flow',
      component: function component() {
        return import('@/views/financial/storeFinance/flow/index');
      },
      name: 'storeFinanceFlow',
      meta: {
        title: '门店流水',
        icon: ''
      }
    }, {
      path: 'bill',
      component: function component() {
        return import('@/views/financial/storeFinance/bill/index');
      },
      name: 'storeFinanceBill',
      meta: {
        title: '账单记录',
        icon: ''
      }
    }]
  }, {
    path: 'record',
    component: function component() {
      return import('@/views/financial/record/index');
    },
    name: 'financialRecord',
    meta: {
      title: '财务记录',
      icon: ''
    },
    alwaysShow: true,
    children: [{
      path: 'charge',
      component: function component() {
        return import('@/views/financial/record/charge/index');
      },
      name: 'Charge',
      meta: {
        title: '充值记录',
        icon: ''
      }
    }, {
      path: 'purchase',
      component: function component() {
        return import('@/views/financial/record/purchase/index');
      },
      name: 'PurchaseRecord',
      meta: {
        title: '购买记录',
        icon: ''
      }
    }, {
      path: 'monitor',
      component: function component() {
        return import('@/views/financial/record/monitor/index');
      },
      name: 'Monitor',
      meta: {
        title: '资金流水',
        icon: ''
      }
    }]
  }, {
    path: 'brokerage',
    component: function component() {
      return import('@/views/financial/brokerage/index');
    },
    name: 'Brokerage',
    meta: {
      title: '佣金记录',
      icon: ''
    }
  }]
};
export default financialRouter;